import React from 'react';
import { volumes } from '../data/coachSystem';
import { CtaButton } from './CtaButton';
export function VolumesSection() {
  return <section className="border-y border-navy-line bg-ivory py-11 sm:py-14" aria-labelledby="volumes-title" data-id="element-137" data-mp="3utm3io1d8bv3">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-138" data-mp="cm51sq12mfl0">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-139" data-mp="7nbmcs284ei7">
          The complete Girls Flag Football Coach System™
        </p>
        <h2 id="volumes-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-140" data-mp="3c4nvqnd4wfhu">
          6 professional volumes.
          <span className="mt-1 block text-navy-muted" data-id="element-141" data-mp="3l39lb2h0wus4">
            One connected coaching system.
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-142" data-mp="2xcx5l5fjdtqz">
          Instead of collecting more random drills, you get one written system
          you return to every week of the season — from the first practice to
          game day.
        </p>

        <ol className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-143" data-mp="2edadc6o4eqig">
          {volumes.map(volume => <li key={volume.number} className="relative flex h-full flex-col items-center overflow-hidden rounded-xl border border-navy-line bg-white p-4 pt-4 text-center sm:p-5" data-id="element-144" data-mp="2j7emmwkuzamp">
              <span className="pointer-events-none absolute -top-2 left-1/2 -translate-x-1/2 select-none font-display text-[3.4rem] font-semibold leading-none text-teal/[0.07] sm:text-[4.2rem]" aria-hidden="true" data-id="element-145" data-mp="1vfpmiu1sphv7">
                {volume.number}
              </span>

              <p className="relative text-[0.55rem] font-bold uppercase tracking-[0.2em] text-teal sm:text-[0.6rem]" data-id="element-146" data-mp="3buimkn53gyrm">
                Volume {String(volume.number).padStart(2, '0')}
              </p>
              <p className="relative mt-1 text-[0.55rem] font-semibold uppercase tracking-[0.16em] text-sand sm:text-[0.6rem]" data-id="element-147" data-mp="1gqb325hwzxu6">
                {volume.stage}
              </p>

              <span className="mt-2.5 block h-px w-7 bg-teal-mid" aria-hidden="true" data-id="element-148" data-mp="1priovo38v67d" />

              <h3 className="mt-2.5 font-display text-[0.95rem] font-medium leading-snug tracking-tight text-navy sm:text-[1.08rem]" data-id="element-149" data-mp="1ks61914jtv3q">
                {volume.title}
              </h3>
              <p className="mt-2 text-[0.78rem] leading-relaxed text-navy-muted sm:text-[0.86rem]" data-id="element-150" data-mp="t1rv5r2s1n2m">
                {volume.benefit}
              </p>
            </li>)}
        </ol>

        <div className="mt-6 flex flex-col items-center gap-4" data-id="element-151" data-mp="1226isx37re9a">
          <p className="mx-auto max-w-xl text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-152" data-mp="11ztrvufh9tk3">
            Together, the six volumes take you from foundations → skills →
            strategy → practice planning → game day without building a single
            session from zero.
          </p>
          <CtaButton label="Get the complete system" variant="teal" className="sm:w-auto" data-id="element-153" data-mp="2kzb7q06jdnq3" />
        </div>
      </div>
    </section>;
}